import {
    type Maybe,
    type LensCompoundId,
    type InputLensCompoundId,
    LenssourceModelLensSourceType as LensSourceType,
} from "../../../gql-generated/types";

export interface LensCompoundIdModel {
    id?: Maybe<string>;
    reference?: Maybe<string>;
    lensSourceType?: Maybe<LensSourceType>;
}

export const LensCompoundIdOperations = {
    toVariables({ id, reference, lensSourceType }: Readonly<LensCompoundIdModel>): InputLensCompoundId {
        return { id, reference, lensSourceType };
    },

    toKey({ id, reference, lensSourceType }: LensCompoundId) {
        return `${id}:${lensSourceType}:${reference}`;
    },
};
